module.exports = __webpack_public_path__ + "static/6317-be3c2826a7810d9e61627434ee0b2970.png";